/*
  sp-differe — les images du bas de l'accueil ne se chargent qu'à l'approche du visiteur.

  Sur une connexion lente, le navigateur précharge les images « lazy » jusqu'à ~2 500 px sous
  l'écran : au téléphone, les cartes de collection et les « Derniers tirages » (≈ 950 Kio)
  partageaient la connexion avec l'image du seuil, qui finissait à 8,1 s pour 111 Kio
  (audit v2, passe vitesse du 2026-10-04). Les images marquées data-sp-differe portent leur
  source en data-sp-src / data-sp-srcset ; elles la reçoivent à 400 px de l'écran.
  Le cadre de la carte (aspect-ratio) réserve la place : rien ne bouge. Sans JS, la copie
  <noscript> posée à côté s'affiche.
*/
(function () {
  if (window.__spDiffere) return;
  window.__spDiffere = true;

  function charger(img) {
    if (img.dataset.spSrcset) img.srcset = img.dataset.spSrcset;
    if (img.dataset.spSrc) img.src = img.dataset.spSrc;
    img.removeAttribute('data-sp-differe');
  }

  function brancher() {
    var imgs = document.querySelectorAll('img[data-sp-differe]');
    if (!imgs.length) return;
    if (!('IntersectionObserver' in window)) {
      imgs.forEach(charger);
      return;
    }
    var io = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (e.isIntersecting) {
          charger(e.target);
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '400px 0px' });
    imgs.forEach(function (img) { io.observe(img); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', brancher);
  else brancher();
})();
